'use client';

import { c as _c } from "react/compiler-runtime";
import { useDialogContext } from '@morpho-org/ui-v6/contexts';
import { useCallback } from 'react';
import { useDialogOnMountDataContext } from '@/contexts/Dialog/DialogOnMountData/DialogOnMountData.context';
import { getActiveDialog } from '@/helpers/dialog';

/**
 * Hook that navigates to the next dialog in queue or closes all dialogs.
 * @returns Function to advance to next dialog or close dialog stack
 */
export const useNextDialog = () => {
  const $ = _c(3);
  const {
    dialogs
  } = useDialogOnMountDataContext();
  const {
    toggleDialog
  } = useDialogContext();
  let t0;
  if ($[0] !== dialogs || $[1] !== toggleDialog) {
    t0 = () => {
      const {
        dialog
      } = getActiveDialog(dialogs);
      if (dialog) {
        toggleDialog(dialog?.component, dialog?.dialogOptions);
      } else {
        toggleDialog(false);
      }
    };
    $[0] = dialogs;
    $[1] = toggleDialog;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};